import React from "react";

import Heading from "components/heading";

import HeroSection from "../../../hero-section";

const title = "Enerflo Plays Nice With Others";

const PlaysNice = () => (
  <HeroSection title={title}>
    <div>
      <HeroSection.Content className="mx-auto md:w-4/5 xl:w-2/3 md:text-center">
        <HeroSection.Header>
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <div className="text-base text-gray-500">
          <p>
            Enerflo is tool agnostic. Prefer your own scheduling tool over our own? Great. Want to keep your project
            management in your own CRM? Fantastic. Enerflo gives you the power of choice to create your platform, your
            way. No two Enerflo’s are the same.
          </p>
          <p className="mt-6 font-bold text-gray-700 text-lg">
            Not seeing your integration? Bring it. We’re up to the challenge!
          </p>
        </div>
      </HeroSection.Content>
    </div>
  </HeroSection>
);

export default PlaysNice;
